import assetPath from '/app/packages/lebenslauf/articles/src/assets/lebenslauf-berufserfahrung.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')